import { createSlice } from '@reduxjs/toolkit';
import { LABELINGCHIMP_SAM_API, LABELGENAPI, LABELINGCHIMP_LABEL_API, INTEGRATIONS_API } from '../../API';
import axios from 'axios';
import { fetchProfile } from '../../pages/Settings/Profile/profileSlice';
import { logFrontendActivity } from '../General/activityLogger';

/* canceling previous requests if multiple requests is triggered */
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const ordersslice = createSlice({
    name: 'orders',
    initialState: {
        ordersData: {
            data: [],
            loading: false,
            meta: {
                page: 1,
                per_page: 10,
                start_date: "",
                end_date: "",
                order_id: "",
                sku: "",
                quantity: "",
                order_status: [],
                receiver_province: "",
                receiver_country_code: "",
                tracking_number: "",
                carrier_name: [],
                platform_tags: [],
                order_tags: [],
                customer_name: "",
                reference_no: "",
                goods_out_note:"",
                shipment_type:0,
                sorting: JSON.stringify([{
                    field: 'order.date',
                    sort: 'desc',
                }])
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        ordersColumns: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        createShipment: {
            loading: false,
            message:"",
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        createShipmentBulk: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        voidShipment: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        manifestClose: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        bulkLabel: {
            loading: false,
            filename: "",
            is_shown: true,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        carriers: {
            loading: false,
            data: [],
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        platformTags: {
            loading: false,
            data: [],
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        assignTags: {
            loading: false,
            data: [],
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        lineItemsWeight: {
            loading: false,
            data: []
        },
        bulkSelectedOrdersData: {
            data: [],
            loading: false,
            meta: {},
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        bulkOrderValidation: {
            loading: false,
            data: [],
        },
        orderUpdate: {
            data: [],
            loading: false,
            meta: {},
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        syncOrderData: {
            loading: false,
            meta: {},
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        orderUIUpdate: {
            data: [],
            loading: false,
            meta: {},
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        addBulkDimension: {
            loading: false,
            data: [],
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        deleteOrders: {
            loading: false,
            data: [],
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        orderNote: {
            data: [],
            loading: false,
            meta: {},
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        orderShipments: {
            data: [],
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        orderShipmentDetails: {
            data: [],
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        orderShipmentLabel: {
            data: [],
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
    },
    reducers: {
        getOrders: (state) => {
            return {
                ...state,
                ordersData: {
                    ...state.ordersData,
                    data:[],
                    loading: true
                }
            }
        },
        getOrdersSuccess: (state, action) => {
            return {
                ...state,
                ordersData: {
                    ...state.ordersData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false
                }
            }
        },
        getOrdersFailure: (state, action) => {
            return {
                ...state,
                ordersData: {
                    ...state.ordersData,
                    loading: false,
                    notification: { show: true, messageContent: action.data && action.data.message, messageType: "error" }
                }
            }
        },
        getBulkSelectedOrders: (state) => {
            return {
                ...state,
                bulkSelectedOrdersData: {
                    ...state.bulkSelectedOrdersData,
                    data:[],
                    loading: true
                }
            }
        },
        getBulkSelectedOrdersSuccess: (state, action) => {
            return {
                ...state,
                bulkSelectedOrdersData: {
                    ...state.bulkSelectedOrdersData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false
                }
            }
        },
        getBulkSelectedOrdersFailure: (state, action) => {
            return {
                ...state,
                bulkSelectedOrdersData: {
                    ...state.bulkSelectedOrdersData,
                    loading: false,
                    notification: { show: true, messageContent: action.data && action.data.message, messageType: "error" }
                }
            }
        },
        getOrdersColumn: (state, action) => {
            return {
                ...state,
                ordersColumns: {
                    ...state.ordersColumns,
                    loading: true
                }
            }
        },
        getOrdersColumnSuccess: (state, action) => {
            return {
                ...state,
                ordersColumns: {
                    ...state.ordersColumns,
                    loading: false,
                    columns: action && action.payload && action.payload.data && action.payload.data.data
                }
            }
        },
        getOrdersColumnFailure: (state, action) => {
            return {
                ...state,
                ordersColumns: {
                    ...state.ordersColumns,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
                }
            }
        },
        postOrdersColumn: (state, action) => {
            return {
                ...state,
                ordersColumns: {
                    ...state.ordersColumns,
                    loading: true
                }
            }
        },
        postOrdersColumnSuccess: (state, action) => {
            return {
                ...state,
                ordersColumns: {
                    ...state.ordersColumns,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        postOrdersColumnFailure: (state, action) => {
            return {
                ...state,
                ordersColumns: {
                    ...state.ordersColumns,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
                }
            }
        },
        postDataCreateShipment: (state, action) => {
            return {
                ...state,
                createShipment: {
                    ...state.createShipment,
                    loading: true
                }
            }
        },
        postDataCreateShipmentSuccess: (state, action) => {
            return {
                ...state,
                createShipment: {
                    ...state.createShipment,
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    loading: false,
                    notification: { show: true, messageContent: (action.payload && action.payload.data && action.payload.data.desc && action.payload.data.desc === "success") ? ["Shipment Created Successfully"] : [""], messageType: "success" }
                }
            }
        },
        postDataCreateShipmentFailure: (state, action) => {
            const payloadData = action.payload?.data;
            let combinedMessages = [];

            if (payloadData) {
                // 1. Extract from 'errors' field based on its structure
                if (payloadData.errors) {
                    // Case A: Errors is an Object (e.g., { "postal_code": ["invalid"] })
                    if (typeof payloadData.errors === "object" && !Array.isArray(payloadData.errors)) {
                        Object.values(payloadData.errors).forEach(errValue => {
                            if (Array.isArray(errValue)) {
                                combinedMessages.push(...errValue.map(v => String(v)));
                            } else {
                                combinedMessages.push(String(errValue));
                            }
                        });
                    } 
                    // Case B: Errors is an Array (e.g., [{ "reason": "..." }] or ["error string"])
                    else if (Array.isArray(payloadData.errors)) {
                        payloadData.errors.forEach(err => {
                            if (typeof err === 'object' && err !== null && err.reason) {
                                // Extract nested 'reason' key if it exists
                                combinedMessages.push(String(err.reason));
                            } else if (err) {
                                combinedMessages.push(String(err));
                            }
                        });
                    }
                }

                // 2. Add the main top-level message if combinedMessages is still empty
                if (combinedMessages.length === 0 && payloadData.message) {
                    combinedMessages.push(payloadData.message);
                }
            }

            // 3. Absolute Fallback
            if (combinedMessages.length === 0) {
                combinedMessages = ["An unknown error occurred during shipment creation"];
            }

            return {
                ...state,
                createShipment: {
                    ...state.createShipment,
                    loading: false,
                    notification: { 
                        show: true, 
                        messageContent: combinedMessages, 
                        messageType: "error" 
                    }
                }
            };
        },
        postDataBulkShipment: (state, action) => {
            return {
                ...state,
                createShipmentBulk: {
                    ...state.createShipmentBulk,
                    loading: true
                }
            }
        },
        postDataBulkShipmentSuccess: (state, action) => {
            return {
                ...state,
                createShipmentBulk: {
                    ...state.createShipmentBulk,
                    loading: false,
                    notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.message, messageType: "success" }
                }
            }
        },
        postDataBulkShipmentFailure: (state, action) => {
            const status = action?.payload?.status || action?.status;
            const payloadData = action?.payload?.data;

            let errorArray = [];

            if (status === 500 || !action?.payload) {
                errorArray = ["Internal Server Error. Unable to process bulk shipment. Please try again later."];
            } else {
                const msg = payloadData?.message || "An unexpected error occurred during bulk shipment processing.";
                
                // ─── FLATTEN IF msg IS ALREADY AN ARRAY ───
                if (Array.isArray(msg)) {
                    errorArray = msg.flat(); // Flatten in case of nested arrays
                } else {
                    errorArray = [msg];
                }
            }

            return {
                ...state,
                createShipmentBulk: {
                    ...state.createShipmentBulk,
                    loading: false,
                    notification: {
                        show: true,
                        messageContent: errorArray, // Now guaranteed to be a flat 1D array
                        messageType: "error",
                        status: status || 500
                    },
                }
            };
        },
        postTrackingNumberVoid: (state, action) => {
            return {
                ...state,
                voidShipment: {
                    ...state.voidShipment,
                    loading: true
                }
            }
        },
        postTrackingNumberVoidSuccess: (state, action) => {
            return {
                ...state,
                voidShipment: {
                    ...state.voidShipment,
                    loading: false,
                    notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.message, messageType: "success" }
                }
            }
        },
        postTrackingNumberVoidFailure: (state, action) => {
            // 1. Identify the HTTP status and payload data
            const status = action?.payload?.status || action?.status;
            const payloadData = action?.payload?.data;

            // 2. Determine the error message array
            let errorArray = [];

            if (status === 500 || !action?.payload) {
                // Specific array handling for 500 errors
                errorArray = ["Internal Server Error. Unable to void the shipment at this time."];
            } else {
                // Extract message and wrap in array for 422 or other errors
                const msg = payloadData?.message || "An error occurred while voiding the shipment.";
                errorArray = [msg];
            }

            return {
                ...state,
                voidShipment: {
                    ...state.voidShipment,
                    loading: false,
                    notification: {
                        show: true,
                        messageContent: errorArray, // ✅ Strictly an array
                        messageType: "error",
                        status: status || 500 // Store status for UI differentiation
                    },
                }
            };
        },
        postTrackingNumberCloseManifest: (state, action) => {
            return {
                ...state,
                manifestClose: {
                    ...state.manifestClose,
                    loading: true
                }
            }
        },
        postTrackingNumberCloseManifestSuccess: (state, action) => {
            return {
                ...state,
                manifestClose: {
                    ...state.manifestClose,
                    loading: false,
                    notification: { show: true, messageContent: (action.payload && action.payload.data && action.payload.data.desc && action.payload.data.desc === "success") ? ["Manifest close triggered successfully"] : [""], messageType: "success" },
                }
            }
        },
       postTrackingNumberCloseManifestFailure: (state, action) => {
            // 1. Robust status detection for 500 errors
            const status = action?.payload?.status || action?.status;
            const payloadData = action?.payload?.data;

            // 2. Determine the error message as an array
            let errorArray = [];

            if (status === 500 || !action?.payload) {
                // Handle server crashes or missing payloads
                errorArray = ["Internal Server Error. Unable to close manifest at this time."];
            } else {
                // Handle standard API errors (422, etc.)
                const msg = payloadData?.message || "An unexpected error occurred while closing the manifest.";
                errorArray = [msg];
            }

            return {
                ...state,
                manifestClose: {
                    ...state.manifestClose,
                    loading: false,
                    notification: {
                        show: true,
                        messageContent: errorArray, // strictly an array for UI mapping
                        messageType: "error",
                        status: status || 500 // Store for conditional UI styling
                    },
                }
            };
        },
        printBulkLabel: (state, action) => {
            return {
                ...state,
                bulkLabel: {
                    ...state.bulkLabel,
                    loading: true
                }
            }
        },
        printBulkLabelSuccess: (state, action) => {
            return {
                ...state,
                bulkLabel: {
                    ...state.bulkLabel,
                    loading: false,
                    is_shown: false,
                    filename: action.payload && action.payload.data && action.payload.data.filename
                }
            }
        },
        printBulkLabelFailure: (state, action) => {
            return {
                ...state,
                bulkLabel: {
                    ...state.bulkLabel,
                    loading: false,
                    notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.message, messageType: "error" }
                }
            }
        },
        getDistinctCarriers: (state, action) => {
            return {
                ...state,
                carriers: {
                    ...state.carriers,
                    loading: true
                }
            }
        },
        getDistinctCarriersSuccess: (state, action) => {
            return {
                ...state,
                carriers: {
                    ...state.carriers,
                    loading: false,
                    data: action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.carriers
                }
            }
        },
        getDistinctCarriersFailure: (state, action) => {
            return {
                ...state,
                carriers: {
                    ...state.carriers,
                    loading: false,
                    notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.message, messageType: "error" }
                }
            }
        },
        getPlatformTags: (state, action) => {
            return {
                ...state,
                platformTags: {
                    ...state.platformTags,
                    loading: true
                }
            }
        },
        getPlatformTagsSuccess: (state, action) => {
            return {
                ...state,
                platformTags: {
                    ...state.platformTags,
                    loading: false,
                    data: action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.platform_tags
                }
            }
        },
        getPlatformTagsFailure: (state, action) => {
            return {
                ...state,
                platformTags: {
                    ...state.platformTags,
                    loading: false,
                    notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.message, messageType: "error" }
                }
            }
        },
        getLineItemsWeight: (state, action) => {
            return {
                ...state,
                lineItemsWeight: {
                    ...state.lineItemsWeight,
                    loading: true
                }
            }
        },
        getLineItemsWeightSuccess: (state, action) => {
            return {
                ...state,
                lineItemsWeight: {
                    ...state.lineItemsWeight,
                    loading: false,
                    data: action.payload && action.payload.data && action.payload.data.data
                }
            }
        },
        getLineItemsWeightFailure: (state, action) => {
            return {
                ...state,
                lineItemsWeight: {
                    ...state.lineItemsWeight,
                    loading: false,
                }
            }
        },
        updateAssignTags: (state, action) => {
            return {
                ...state,
                assignTags: {
                    ...state.assignTags,
                    loading: true
                }
            }
        },
        updateAssignTagsSuccess: (state, action) => {
            return {
                ...state,
                assignTags: {
                    ...state.assignTags,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        updateAssignTagsFailure: (state, action) => {
            return {
                ...state,
                assignTags: {
                    ...state.assignTags,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }

                }
            }
        },
        orderUpdate: (state, action) => {
            return {
                ...state,
                orderUpdate: {
                    ...state.orderUpdate,
                    loading: true
                }
            }
        },
        orderUpdateSuccess: (state, action) => {
            return {
                ...state,
                orderUpdate: {
                    ...state.orderUpdate,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        orderUpdateFailure: (state, action) => {
            return {
                ...state,
                orderUpdate: {
                    ...state.orderUpdate,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }

                }
            }
        },

        syncOrderData: (state, action) => {
            return {
                ...state,
                syncOrderData: {
                    ...state.syncOrderData,
                    loading: true
                }
            }
        },
        syncOrderDataSuccess: (state, action) => {
            return {
                ...state,
                syncOrderData: {
                    ...state.syncOrderData,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        syncOrderDataFailure: (state, action) => {
            return {
                ...state,
                syncOrderData: {
                    ...state.syncOrderData,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }

                }
            }
        },
        postDataBulkOrderValidation: (state, action) => {
            return {
                ...state,
                bulkOrderValidation: {
                    ...state.bulkOrderValidation,
                    loading: true,
                    data:[]
                }
            }
        },
        postDataBulkOrderValidationSuccess: (state, action) => {
            return {
                ...state,
                bulkOrderValidation: {
                    ...state.bulkOrderValidation,
                    loading: false,
                    data:action.payload && action.payload.data && action.payload.data.data
                }
            }
        },
        postDataBulkOrderValidationFailure: (state, action) => {
            return {
                ...state,
                bulkOrderValidation: {
                    ...state.bulkOrderValidation,
                    loading: false,
                    data:[]
                }
            }
        },

        getOrdersUIUpdate: (state) => {
            return {
                ...state,
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    data:[],
                    loading: true
                }
            }
        },
        getOrdersUIUpdateSuccess: (state, action) => {
            return {
                ...state,
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false
                }
            }
        },
        getOrdersUIUpdateFailure: (state, action) => {
            return {
                ...state,
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    loading: false,
                    notification: { show: true, messageContent: action.data && action.data.message, messageType: "error" }
                }
            }
        },
        postDatagridData: (state) => {
            return {
                ...state,
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    data:[],
                    loading: true
                }
            }
        },
        postDatagridDataSuccess: (state, action) => {
            return {
                ...state,
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" },
                    loading: false
                }
            }
        },
        postDatagridDataFailure: (state, action) => {
            return {
                ...state,
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    loading: false,
                    notification: { show: true, messageContent: action.data && action.data.message, messageType: "error" }
                }
            }
        },
        postBulkDimensions: (state, action) => {
            return {
                ...state,
                addBulkDimension: {
                    ...state.addBulkDimension,
                    loading: true
                }
            }
        },
        postBulkDimensionsSuccess: (state, action) => {
            return {
                ...state,
                addBulkDimension: {
                    ...state.addBulkDimension,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        postBulkDimensionsFailure: (state, action) => {
            return {
                ...state,
                addBulkDimension: {
                    ...state.addBulkDimension,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }

                }
            }
        },
        
        deleteOrdersData: (state, action) => {
            return {
                ...state,
                deleteOrders: {
                    ...state.deleteOrders,
                    loading: true
                }
            }
        },
        deleteOrdersDataSuccess: (state, action) => {
            return {
                ...state,
                deleteOrders: {
                    ...state.deleteOrders,
                    loading: false,
                    data:action.payload && action.payload.data,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
                }
            }
        },
        deleteOrdersDataFailure: (state, action) => {
            return {
                ...state,
                deleteOrders: {
                    ...state.deleteOrders,
                    loading: false,
                    data:action.payload && action.payload.data,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }

                }
            }
        },

        orderNoteChange: (state, action) => {
            return {
                ...state,
                orderNote: {
                    ...state.orderNote,
                    loading: true
                }
            }
        },
        orderNoteChangeSuccess: (state, action) => {
            return {
                ...state,
                orderNote: {
                    ...state.orderNote,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" }
                }
            }
        },
        orderNoteChangeFailure: (state, action) => {
            return {
                ...state,
                orderNote: {
                    ...state.orderNote,
                    loading: false,
                    notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }

                }
            }
        },
        getOrderShipments: (state) => {
            state.orderShipments.loading = true;
            state.orderShipments.data = [];
        },
        getOrderShipmentsSuccess: (state, action) => {
            state.orderShipments.loading = false;
            state.orderShipments.data = action.payload && action.payload.data && action.payload.data.data;
        },
        getOrderShipmentsFailure: (state, action) => {
            state.orderShipments.loading = false;
            state.orderShipments.notification = { 
                show: true, 
                messageContent: action.payload?.data?.message || "Failed to fetch shipments", 
                messageType: "error" 
            };
        },
        getOrderShipmentDetails: (state) => {
            state.orderShipmentDetails.loading = true;
            state.orderShipmentDetails.data = [];
        },
        getOrderShipmentDetailsSuccess: (state, action) => {
            state.orderShipmentDetails.loading = false;
            // Maps the nested data structure from your API response
            state.orderShipmentDetails.data = action.payload?.data?.data || action.payload?.data;
        },
        getOrderShipmentDetailsFailure: (state, action) => {
            state.orderShipmentDetails.loading = false;
            state.orderShipmentDetails.notification = { 
                show: true, 
                messageContent: action.payload?.data?.message || "Failed to fetch shipment details", 
                messageType: "error" 
            };
        },
        getOrderShipmentLabel: (state) => {
            state.orderShipmentLabel.loading = true;
            state.orderShipmentLabel.data = [];
        },
        getOrderShipmentLabelSuccess: (state, action) => {
            state.orderShipmentLabel.loading = false;
            state.orderShipmentLabel.data = action.payload && action.payload.data && action.payload.data.data;
        },
        getOrderShipmentLabelFailure: (state, action) => {
            state.orderShipmentLabel.loading = false;
            state.orderShipmentLabel.notification = { 
                show: true, 
                messageContent: action.payload?.data?.message || "Failed to fetch shipments", 
                messageType: "error" 
            };
        },
        clearOrderShipmentDetails: (state) => {
            return {
                ...state,
                orderShipmentDetails: {
                    ...state.orderShipmentDetails,
                    data: null,      // Clear the data
                    loading: false   // ✅ THIS STOPS THE DATAGRID LOADING
                }
            }
        },
        clearOrderShipmentLabel: (state) => {
            return {
                ...state,
                orderShipmentLabel: {
                    ...state.orderShipmentLabel,
                    data: [],      // Clear the data
                    loading: false   // ✅ THIS STOPS THE DATAGRID LOADING
                }
            }
        },
        resetOrderNotification: (state, action) => {
            return {
                ...state,
                ordersData: {
                    ...state.ordersData,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                ordersColumns: {
                    ...state.ordersColumns,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                createShipment: {
                    ...state.createShipment,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                createShipmentBulk: {
                    ...state.createShipmentBulk,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                voidShipment: {
                    ...state.voidShipment,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                manifestClose: {
                    ...state.manifestClose,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                bulkLabel: {
                    ...state.bulkLabel,
                    filename: "",
                    is_shown: true,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                carriers: {
                    ...state.carriers,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                platformTags: {
                    ...state.platformTags,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                assignTags: {
                    ...state.assignTags,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                orderUpdate: {
                    ...state.orderUpdate,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                syncOrderData: {
                    ...state.syncOrderData,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                orderUIUpdate: {
                    ...state.orderUIUpdate,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                bulkOrderValidation:{
                    ...state.bulkOrderValidation,
                    data: []
                },
                addBulkDimension: {
                    ...state.addBulkDimension,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                deleteOrders: {
                    ...state.deleteOrders,
                    data:[],
                    notification: { show: false, messageContent: "", messageType: "success" }
                }
            }
        },
        resetOrderUpdateNotificationsData: (state, action) => {
            return {
                ...state,
                orderUpdate: {
                    ...state.orderUpdate,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
            }
        },
        resetOrderNoteNotification: (state, action) => {
            return {
                ...state,
                orderNote: {
                    ...state.orderNote,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
            }
        }
    }
})
export const { getOrders, getOrdersSuccess, getOrdersFailure,clearOrderShipmentDetails,clearOrderShipmentLabel } = ordersslice.actions;

export const fetchOrders = meta => dispatch => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');
    dispatch(getOrders());
    try {
        source && source.cancel('Operation canceled due to new request.');
        source = axios.CancelToken.source();
        LABELGENAPI.get('/orders/info?' + qs, {
            cancelToken: source.token
        }).then(function (response) {
            dispatch(getOrdersSuccess(response));
            dispatch(fetchProfile());
        }).catch(function (error) {
            if (!axios.isCancel(error)) {
                dispatch(getOrdersFailure(error.response));
            }
        });
    } catch (error) {
        if (!axios.isCancel(error)) {
            dispatch(getOrdersFailure(error.response));
        }
    }
};

export const { getOrdersColumn, getOrdersColumnSuccess, getOrdersColumnFailure } = ordersslice.actions;

export const fetchOrderColumns = () => {
    return (dispatch) => {
        dispatch(getOrdersColumn());
        try {
            LABELGENAPI
                .get('/orders/columns')
                .then(function (response) {
                    dispatch(getOrdersColumnSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getOrdersColumnFailure(error.response));
                });
        } catch (error) {
            dispatch(getOrdersColumnFailure());
        }
    };
};

export const { postOrdersColumn, postOrdersColumnSuccess, postOrdersColumnFailure } = ordersslice.actions;

export const saveOrdersColumns = (userid, data) => {
    return (dispatch) => {
        dispatch(postOrdersColumn());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/orders/columns', data, { 
                headers: { 
                    'x-log-ref': logRef
                    } 
                })
                .then(function (response) {
                    dispatch(postOrdersColumnSuccess(response));
                    logFrontendActivity({
                        group: 'DYNAMIC_COLUMNS',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });   
                    dispatch(fetchOrderColumns());
                })
                .catch(function (error) {
                    dispatch(postOrdersColumnFailure(error.response));
                    logFrontendActivity({
                        group: 'DYNAMIC_COLUMNS',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    }); 
                });
        } catch (error) {
            dispatch(postOrdersColumnFailure());
            logFrontendActivity({
                group: 'DYNAMIC_COLUMNS',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            }); 
        }
    };
};

export const { postDataCreateShipment, postDataCreateShipmentSuccess, postDataCreateShipmentFailure } = ordersslice.actions;

export const dopostDataCreateShipment = (reportName,userid,orderid, data, api_token, meta) => {
    console.log(reportName)
    return (dispatch) => {
        dispatch(postDataCreateShipment());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_SAM_API
                .post('/create-shipment', data, { headers: { 'x-api-key': api_token, 'Content-Type': 'application/json' } })
                .then(function (response) {
                    dispatch(postDataCreateShipmentSuccess(response));
                    // logFrontendActivity({
                    //     group: 'CREATE_SHIPMENT',
                    //     subgroup: reportName,
                    //     action: 'SUCCESS',
                    //     request_data: data,
                    //     response_data: response.data,
                    //     log_ref: logRef,
                    //     userid: userid,
                    //     orderid : orderid,
                    //     tracking_number : response.data.message.trackingnumber
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }else{
                    //         console.log('Activity log failed:', ref);
                    //     }
                    // });  
                    try {
                        if (response.data.desc === "success") {
                            setTimeout(() => { dispatch(fetchOrders(meta)) }, 1000);
                        }
                    } catch (error) {
                        dispatch(postDataCreateShipmentFailure(error.response));
                        // logFrontendActivity({
                        //     group: 'CREATE_SHIPMENT',
                        //     subgroup: reportName,
                        //     action: 'FAILURE',
                        //     request_data: data,
                        //     response_data: error.response?.data || {},
                        //     log_ref: logRef,
                        //     userid: userid,
                        //     orderid : orderid
                        // }).then((ref) => {
                        //     if (ref) {
                        //         console.log('Activity log recorded with log_ref:', ref);
                        //     }
                        // }); 
                    }
                })
                .catch(function (error) {
                    dispatch(postDataCreateShipmentFailure(error.response));
                    // logFrontendActivity({
                    //     group: 'CREATE_SHIPMENT',
                    //     subgroup: reportName,
                    //     action: 'FAILURE',
                    //     request_data: data,
                    //     response_data: error.response?.data || {},
                    //     log_ref: logRef,
                    //     userid: userid,
                    //     orderid : orderid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }
                    // }); 
                });
        } catch (error) {
            dispatch(postDataCreateShipmentFailure());
            // logFrontendActivity({
            //     group: 'CREATE_SHIPMENT',
            //     subgroup: reportName,
            //     action: 'FAILURE',
            //     request_data: data,
            //     response_data: error.response?.data || {},
            //     log_ref: logRef,
            //     userid: userid,
            //     orderid : orderid
            // }).then((ref) => {
            //     if (ref) {
            //         console.log('Activity log recorded with log_ref:', ref);
            //     }
            // }); 
        }
    };
};

export const { postDataBulkShipment, postDataBulkShipmentSuccess, postDataBulkShipmentFailure } = ordersslice.actions;

export const dopostDataBulkShipment = (userid, data, api_token, meta) => {
    return (dispatch) => {
        dispatch(postDataBulkShipment());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_SAM_API
                .post('/bulk-create-order-shipment', data, { headers: { 'x-api-key': api_token, 'Content-Type': 'application/json' } })
                .then(function (response) {
                    dispatch(postDataBulkShipmentSuccess(response));
                    // logFrontendActivity({
                    //     group: 'BULK_CREATE_SHIPMENT',
                    //     subgroup: 'ORDERS',
                    //     action: 'SUCCESS',
                    //     request_data: data,
                    //     response_data: response.data,
                    //     log_ref: logRef,
                    //     userid: userid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }else{
                    //         console.log('Activity log failed:', ref);
                    //     }
                    // });  
                    try {
                        if (response.data.desc === "success") {
                            setTimeout(() => { dispatch(fetchOrders(meta)) }, 3000);
                        }
                    } catch (error) {
                        dispatch(postDataBulkShipmentFailure(error.response));
                        // logFrontendActivity({
                        //     group: 'BULK_CREATE_SHIPMENT',
                        //     subgroup: 'ORDERS',
                        //     action: 'FAILURE',
                        //     request_data: data,
                        //     response_data: error.response?.data || {},
                        //     log_ref: logRef,
                        //     userid: userid
                        // }).then((ref) => {
                        //     if (ref) {
                        //         console.log('Activity log recorded with log_ref:', ref);
                        //     }
                        // });
                    }
                })
                .catch(function (error) {
                    dispatch(postDataBulkShipmentFailure(error.response));
                    // logFrontendActivity({
                    //     group: 'BULK_CREATE_SHIPMENT',
                    //     subgroup: 'ORDERS',
                    //     action: 'FAILURE',
                    //     request_data: data,
                    //     response_data: error.response?.data || {},
                    //     log_ref: logRef,
                    //     userid: userid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }
                    // });
                });
        } catch (error) {
            dispatch(postDataBulkShipmentFailure());
            // logFrontendActivity({
            //     group: 'BULK_CREATE_SHIPMENT',
            //     subgroup: 'ORDERS',
            //     action: 'FAILURE',
            //     request_data: data,
            //     response_data: error.response?.data || {},
            //     log_ref: logRef,
            //     userid: userid
            // }).then((ref) => {
            //     if (ref) {
            //         console.log('Activity log recorded with log_ref:', ref);
            //     }
            // });
        }
    };
};


export const { postTrackingNumberVoid, postTrackingNumberVoidSuccess, postTrackingNumberVoidFailure } = ordersslice.actions;

export const doPostTrackingNumberVoid = (userid, data, api_token, updateOrderData, meta) => {
    return (dispatch) => {
        dispatch(postTrackingNumberVoid());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_SAM_API
                .post('/void-label', data, { headers: { 'x-api-key': api_token, 'Content-Type': 'application/json' } })
                .then(function (response) {
                    dispatch(postTrackingNumberVoidSuccess(response));
                    // logFrontendActivity({
                    //     group: 'VOID_SHIPMENT',
                    //     subgroup: 'ORDERS',
                    //     action: 'SUCCESS',
                    //     request_data: data,
                    //     response_data: response.data,
                    //     log_ref: logRef,
                    //     userid: userid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }else{
                    //         console.log('Activity log failed:', ref);
                    //     }
                    // }); 
                    try {
                        if (response.data.desc === "success") {
                            setTimeout(() => { dispatch(fetchOrders(meta)) }, 3000);
                        }
                    } catch (error) {
                        dispatch(postTrackingNumberVoidFailure(error.response));
                        // logFrontendActivity({
                        //         group: 'VOID_SHIPMENT',
                        //         subgroup: 'ORDERS',
                        //         action: 'FAILURE',
                        //         request_data: data,
                        //         response_data: error.response?.data || {},
                        //         log_ref: logRef,
                        //         userid: userid
                        //     }).then((ref) => {
                        //         if (ref) {
                        //             console.log('Activity log recorded with log_ref:', ref);
                        //         }
                        //     });
                    }
                })
                .catch(function (error) {
                    dispatch(postTrackingNumberVoidFailure(error.response));
                    //  logFrontendActivity({
                    //     group: 'VOID_SHIPMENT',
                    //     subgroup: 'ORDERS',
                    //     action: 'FAILURE',
                    //     request_data: data,
                    //     response_data: error.response?.data || {},
                    //     log_ref: logRef,
                    //     userid: userid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }
                    // });
                });
        } catch (error) {
            dispatch(postTrackingNumberVoidFailure());
            logFrontendActivity({
                group: 'VOID_SHIPMENT',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { printBulkLabel, printBulkLabelSuccess, printBulkLabelFailure } = ordersslice.actions;

export const printBulkLabels = (data, userid) => {
    return (dispatch) => {
        dispatch(printBulkLabel());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_LABEL_API
                .post('/merge-pdf?&file_prefix=label&user_id=' + userid, data)
                .then(function (response) {
                    dispatch(printBulkLabelSuccess(response));
                    logFrontendActivity({
                        group: 'BULK_LABEL_PRINT',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                    dispatch(resetOrderNotification());
                })
                .catch(function (error) {
                    dispatch(printBulkLabelFailure(error.response));
                    dispatch(resetOrderNotification());
                    logFrontendActivity({
                        group: 'BULK_LABEL_PRINT',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(printBulkLabelFailure());
            logFrontendActivity({
                group: 'BULK_LABEL_PRINT',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { getDistinctCarriers, getDistinctCarriersSuccess, getDistinctCarriersFailure } = ordersslice.actions;

export const fetchDistinctCarriers = () => {
    return (dispatch) => {
        dispatch(getDistinctCarriers());
        try {
            LABELGENAPI
                .get('/orders/distinct-carriers')
                .then(function (response) {
                    dispatch(getDistinctCarriersSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getDistinctCarriersFailure(error.response));
                });
        } catch (error) {
            dispatch(getDistinctCarriersFailure());
        }
    };
};

export const { getPlatformTags, getPlatformTagsSuccess, getPlatformTagsFailure } = ordersslice.actions;

export const fetchPlatformTags = () => {
    return (dispatch) => {
        dispatch(getPlatformTags());
        try {
            LABELGENAPI
                .get('/orders/platform-tags')
                .then(function (response) {
                    dispatch(getPlatformTagsSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getPlatformTagsFailure(error.response));
                });
        } catch (error) {
            dispatch(getPlatformTagsFailure());
        }
    };
};


export const { postTrackingNumberCloseManifest, postTrackingNumberCloseManifestSuccess, postTrackingNumberCloseManifestFailure } = ordersslice.actions;

export const dopostTrackingNumberCloseManifest = (userid, data, api_token, meta) => {
    return (dispatch) => {
        dispatch(postTrackingNumberCloseManifest());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_SAM_API
                .post('/close-manifest', data, { headers: { 'x-api-key': api_token, 'Content-Type': 'application/json' } })
                .then(function (response) {
                    dispatch(postTrackingNumberCloseManifestSuccess(response));
                     logFrontendActivity({
                        group: 'MANIFEST_CLOSE',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                    try {
                        if (response.data.desc === "success") {
                            setTimeout(() => { dispatch(fetchOrders(meta)) }, 3000);
                        }
                    } catch (error) {
                        dispatch(postTrackingNumberCloseManifestFailure(error.response));
                        logFrontendActivity({
                            group: 'MANIFEST_CLOSE',
                            subgroup: 'ORDERS',
                            action: 'FAILURE',
                            request_data: data,
                            response_data: error.response?.data || {},
                            log_ref: logRef,
                            userid: userid
                        }).then((ref) => {
                            if (ref) {
                                console.log('Activity log recorded with log_ref:', ref);
                            }
                        });
                    }
                })
                .catch(function (error) {
                    dispatch(postTrackingNumberCloseManifestFailure(error.response));
                    logFrontendActivity({
                        group: 'MANIFEST_CLOSE',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(postTrackingNumberCloseManifestFailure());
             logFrontendActivity({
                group: 'MANIFEST_CLOSE',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { getLineItemsWeight, getLineItemsWeightSuccess, getLineItemsWeightFailure } = ordersslice.actions;

export const fetchLineItemsWeight = () => {
    return (dispatch) => {
        dispatch(getLineItemsWeight());
        try {
            LABELGENAPI
                .get('/settings/getlineitemsweight')
                .then(function (response) {
                    dispatch(getLineItemsWeightSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getLineItemsWeightFailure(error.response));
                });
        } catch (error) {
            dispatch(getLineItemsWeightFailure());
        }
    };
};


export const { updateAssignTags, updateAssignTagsSuccess, updateAssignTagsFailure } = ordersslice.actions;

export const updateAssignTag = (userid, data,meta) => {
    return (dispatch) => {
        dispatch(updateAssignTags());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/orders/assign-tags',data, { 
                headers: { 
                    'x-log-ref': logRef
                    } 
                })
                .then(function (response) {
                    dispatch(updateAssignTagsSuccess(response));
                    dispatch(fetchOrders(meta))
                    logFrontendActivity({
                        group: 'TAG_ASSIGN',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(updateAssignTagsFailure(error.response));
                    logFrontendActivity({
                        group: 'TAG_ASSIGN',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(updateAssignTagsFailure());
            logFrontendActivity({
                group: 'TAG_ASSIGN',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { getBulkSelectedOrders, getBulkSelectedOrdersSuccess, getBulkSelectedOrdersFailure } = ordersslice.actions;

export const fetchBulkSelectedOrders = meta => dispatch => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');
    dispatch(getBulkSelectedOrders());
    try {
        source && source.cancel('Operation canceled due to new request.');
        source = axios.CancelToken.source();
        LABELGENAPI.get('/orders/docinfo?' + qs, {
            cancelToken: source.token
        }).then(function (response) {
            dispatch(getBulkSelectedOrdersSuccess(response));
        }).catch(function (error) {
            if (!axios.isCancel(error)) {
                dispatch(getBulkSelectedOrdersFailure(error.response));
            }
        });
    } catch (error) {
        if (!axios.isCancel(error)) {
            dispatch(getBulkSelectedOrdersFailure(error.response));
        }
    }
};

export const { orderUpdate, orderUpdateSuccess, orderUpdateFailure } = ordersslice.actions;

export const orderUpdateData = (userid, data,meta) => {
    return (dispatch) => {
        dispatch(orderUpdate());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/orders/order-update',data, { 
                headers: { 
                    'x-log-ref': logRef
                    } 
                })
                .then(function (response) {
                    dispatch(orderUpdateSuccess(response));
                    dispatch(fetchOrders(meta));
                    logFrontendActivity({
                        group: 'ORDER_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(orderUpdateFailure(error.response));
                    logFrontendActivity({
                        group: 'ORDER_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(orderUpdateFailure());
            logFrontendActivity({
                group: 'ORDER_UPDATE',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { syncOrderData, syncOrderDataSuccess, syncOrderDataFailure } = ordersslice.actions;

export const syncOrderDatas = (userid, data) => {
    return (dispatch) => {
        dispatch(syncOrderData());
        const logRef = crypto.randomUUID();
        try {
            INTEGRATIONS_API
                .post('ss/today-orders?apikey='+data)
                .then(function (response) {
                    dispatch(syncOrderDataSuccess(response));
                    logFrontendActivity({
                        group: 'SYNC_ORDER_DATA',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(syncOrderDataFailure(error.response));
                    logFrontendActivity({
                        group: 'SYNC_ORDER_DATA',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(syncOrderDataFailure());
            logFrontendActivity({
                group: 'SYNC_ORDER_DATA',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { postDataBulkOrderValidation, postDataBulkOrderValidationSuccess, postDataBulkOrderValidationFailure } = ordersslice.actions;

export const postBulkOrderValidation = (userid,data) => {
    return (dispatch) => {
        dispatch(postDataBulkOrderValidation());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/bulk-shipments/bulk-orders-validate',data)
                .then(function (response) {
                    dispatch(postDataBulkOrderValidationSuccess(response));
                    logFrontendActivity({
                        group: 'BULK_ORDER_VALIDATION',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(postDataBulkOrderValidationFailure(error.response));
                    logFrontendActivity({
                        group: 'BULK_ORDER_VALIDATION',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(postDataBulkOrderValidationFailure());
            logFrontendActivity({
                group: 'BULK_ORDER_VALIDATION',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { getOrdersUIUpdate, getOrdersUIUpdateSuccess, getOrdersUIUpdateFailure } = ordersslice.actions;


export const fetchOrdersUI = (data) => {
    return (dispatch) => {
        dispatch(getOrdersUIUpdate());
        try {
            LABELGENAPI.get('/config/data-grid?report_name=orders')
                .then(function (response) {
                    dispatch(getOrdersUIUpdateSuccess(response));
                }).catch(function (error) {
                    dispatch(getOrdersUIUpdateFailure(error.response));
                })
        }catch (error) {
            dispatch(getOrdersUIUpdateFailure(error.response));
        }
    };
};
export const { postDatagridData, postDatagridDataSuccess, postDatagridDataFailure } = ordersslice.actions;

export const storeDatagridData = (userid, data) => {
    return (dispatch) => {
        dispatch(postDatagridData());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI.post('/config/data-grid', data)
                .then(function (response) {
                    dispatch(postDatagridDataSuccess(response));
                    dispatch(fetchOrdersUI());
                    logFrontendActivity({
                        group: 'DATAGRID_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                }).catch(function (error) {
                    dispatch(postDatagridDataFailure(error.response));
                    logFrontendActivity({
                        group: 'DATAGRID_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                })
        }
        catch (error) {
            dispatch(postDatagridDataFailure(error.response));
            logFrontendActivity({
                group: 'DATAGRID_UPDATE',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    }
}

export const { postBulkDimensions, postBulkDimensionsSuccess, postBulkDimensionsFailure } = ordersslice.actions;

export const updateBulkDimension = (userid,data,meta) => {
    return (dispatch) => {
        dispatch(postBulkDimensions());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/orders/addbulkdimension',data)
                .then(function (response) {
                    dispatch(postBulkDimensionsSuccess(response));
                    dispatch(fetchOrders(meta))
                    logFrontendActivity({
                        group: 'BULK_DIMENSIONS_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(postBulkDimensionsFailure(error.response));
                    logFrontendActivity({
                        group: 'BULK_DIMENSIONS_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(postBulkDimensionsFailure());
            logFrontendActivity({
                group: 'BULK_DIMENSIONS_UPDATE',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { deleteOrdersData, deleteOrdersDataSuccess, deleteOrdersDataFailure } = ordersslice.actions;

export const postdeleteOrdersData = (userid,data) => {
    return (dispatch) => {
        dispatch(deleteOrdersData());
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/orders/order-delete',data)
                .then(function (response) {
                    dispatch(deleteOrdersDataSuccess(response));
                    logFrontendActivity({
                        group: 'ORDER_DELETE',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(deleteOrdersDataFailure(error.response));
                    logFrontendActivity({
                        group: 'ORDER_DELETE',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(deleteOrdersDataFailure());
            logFrontendActivity({
                group: 'ORDER_DELETE',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

export const { orderNoteChange, orderNoteChangeSuccess, orderNoteChangeFailure } = ordersslice.actions;

export const modifyOrderNote = (userid,data,meta) => {
    return (dispatch) => {
        dispatch((orderNoteChange()));
        const logRef = crypto.randomUUID();
        try {
            LABELGENAPI
                .post('/orders/order-note',data)
                .then(function (response) {
                    dispatch(orderNoteChangeSuccess(response));
                    dispatch(fetchOrders(meta))
                    logFrontendActivity({
                        group: 'ORDER_NOTE_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'SUCCESS',
                        request_data: data,
                        response_data: response.data,
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }else{
                            console.log('Activity log failed:', ref);
                        }
                    });
                })
                .catch(function (error) {
                    dispatch(orderNoteChangeFailure(error.response));
                    logFrontendActivity({
                        group: 'ORDER_NOTE_UPDATE',
                        subgroup: 'ORDERS',
                        action: 'FAILURE',
                        request_data: data,
                        response_data: error.response?.data || {},
                        log_ref: logRef,
                        userid: userid
                    }).then((ref) => {
                        if (ref) {
                            console.log('Activity log recorded with log_ref:', ref);
                        }
                    });
                });
        } catch (error) {
            dispatch(orderNoteChangeFailure());
            logFrontendActivity({
                group: 'ORDER_NOTE_UPDATE',
                subgroup: 'ORDERS',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        }
    };
};

// Export the actions
export const { 
    getOrderShipments, 
    getOrderShipmentsSuccess, 
    getOrderShipmentsFailure 
} = ordersslice.actions;

// Create the fetch function
export const fetchOrderShipments = (order_docid) => {
    return (dispatch) => {
        dispatch(getOrderShipments());
        try {
            // Using params: { order_docid } for the GET request
            LABELGENAPI
                .get('/orders/order-shipments', { 
                    params: { order_docid: order_docid } 
                })
                .then(function (response) {
                    dispatch(getOrderShipmentsSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getOrderShipmentsFailure(error.response));
                });
        } catch (error) {
            dispatch(getOrderShipmentsFailure());
        }
    };
};

// Export the new actions
export const { 
    getOrderShipmentDetails, 
    getOrderShipmentDetailsSuccess, 
    getOrderShipmentDetailsFailure 
} = ordersslice.actions;

// The new fetch function
export const fetchOrderShipmentDetails = (order_docid) => {
    return (dispatch) => {
        dispatch(getOrderShipmentDetails());
        try {
            LABELGENAPI
                .get('/orders/order-shipments-details', { 
                    params: { order_docid: order_docid } 
                })
                .then(function (response) {
                    dispatch(getOrderShipmentDetailsSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getOrderShipmentDetailsFailure(error.response));
                });
        } catch (error) {
            dispatch(getOrderShipmentDetailsFailure());
        }
    };
};

export const fetchBulkOrderShipmentDetails = (order_docids) => {
    return (dispatch) => {
        dispatch(getOrderShipmentDetails());
        LABELGENAPI
            .post('/orders/bulk-shipment-labels', { order_docids }) // Using POST for many IDs
            .then((response) => {
                dispatch(getOrderShipmentDetailsSuccess(response));
            })
            .catch((error) => {
                dispatch(getOrderShipmentDetailsFailure(error.response));
            });
    };
};

export const { 
    getOrderShipmentLabel, 
    getOrderShipmentLabelSuccess, 
    getOrderShipmentLabelFailure 
} = ordersslice.actions;

// The new fetch function
export const fetchOrderShipmentLabel = (order_docid,tracking_number, requestType) => {
    return (dispatch) => {
        dispatch(getOrderShipmentLabel());
        try {
            LABELGENAPI
                .get('/orders/order-shipment-labels', { 
                    params: { order_docid: order_docid,tracking_number: tracking_number,"requestType":requestType } 
                })
                .then(function (response) {
                    dispatch(getOrderShipmentLabelSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getOrderShipmentLabelFailure(error.response));
                });
        } catch (error) {
            dispatch(getOrderShipmentLabelFailure());
        }
    };
};

export const { resetOrderNotification } = ordersslice.actions;

export const resetOrderNotifications = () => {
    return (dispatch) => {
        dispatch(resetOrderNotification());
    }
}
export const { resetOrderNoteNotification } = ordersslice.actions;

export const resetOrderNoteNotifications = () => {
    return (dispatch) => {
        dispatch(resetOrderNoteNotification());
    }
}
export const { resetOrderUpdateNotificationsData } = ordersslice.actions;

export const resetOrderUpdateNotifications = () => {
    return (dispatch) => {
        dispatch(resetOrderUpdateNotificationsData());
    }
}

export default ordersslice.reducer;
